// Simple mapping from portal display name to canonical URL.
// Keep lightweight; can be extended or moved to backend later.
const MAP: Record<string, string> = {
  'comprasnet': 'https://www.comprasnet.gov.br',
  'licitacoes-e': 'https://www.licitacoes-e.com.br',
  'portal de compras públicas': 'https://www.gov.br/compras',
  'bll compras': 'https://www.bll.com.br',
  'conlicitação': 'https://www.conlicitacao.com.br',
  'bec-sp': 'https://www.bec.sp.gov.br',
};

export function getPortalUrl(name?: string | null) {
  if (!name) return undefined;
  const key = name.trim().toLowerCase();
  return MAP[key] || undefined;
}

export default { getPortalUrl };
